import {
	answerQuestion,
	checkUserName,
	clearContestPointsRequest,
	fetchAllLeaderboardsData,
	fetchAllTimeLeaderboard,
	fetchContestResultsRequest,
	fetchContestsRequest,
	fetchDailyLeaderboard,
	fetchLeaderProfile,
	fetchPlayersRequest,
	fetchSquadsRequest,
	fetchYesterdayLeaderboard,
	gameStart,
	getSessionUser,
	loginBackdoorRequest,
	sendThanksForPlayingViewed,
	sendTutorialModalViewed,
	sendWhatsNewModalViewed,
	userLogin,
	fetchContextualPrompt,
	declineContextualPrompt,
} from "modules/actions";
import {all, takeLatest} from "typed-redux-saga";
import {
	checkUserNameSaga,
	loginBackdoorSaga,
	processLoginSaga,
	processSessionSaga,
	sendThanksForPlayingViewedSaga,
	setTutorialModalViewedSaga,
	setWhatsNewModalViewedSaga,
} from "modules/sagas/user";
import {
	answerQuestionSaga,
	clearContestPointsSaga,
	fetchContestResultsSaga,
	fetchContestsSaga,
	gameStartSaga,
} from "modules/sagas/contest";
import {fetchPlayersSaga, fetchSquadsSaga} from "modules/sagas/JSON";
import {
	fetchAllLeaderboardsDataSaga,
	fetchAllTimeLeaderboardSaga,
	fetchDailyLeaderboardSaga,
	fetchLeaderProfileSaga,
	fetchYesterdayLeaderboardSaga,
} from "modules/sagas/leaderboards";
import {
	fetchContextualPromptSaga,
	declineContextualPromptSaga,
} from "modules/sagas/contextualPrompt";

export const rootSaga = function* () {
	yield* all([
		takeLatest(userLogin, processLoginSaga),
		takeLatest(getSessionUser, processSessionSaga),
		takeLatest(checkUserName, checkUserNameSaga),
		takeLatest(loginBackdoorRequest, loginBackdoorSaga),
		takeLatest(fetchContestsRequest, fetchContestsSaga),
		takeLatest(fetchPlayersRequest, fetchPlayersSaga),
		takeLatest(fetchSquadsRequest, fetchSquadsSaga),
		takeLatest(gameStart, gameStartSaga),
		takeLatest(answerQuestion, answerQuestionSaga),
		takeLatest(fetchContestResultsRequest, fetchContestResultsSaga),
		takeLatest(clearContestPointsRequest, clearContestPointsSaga),
		takeLatest(sendWhatsNewModalViewed, setWhatsNewModalViewedSaga),
		takeLatest(sendTutorialModalViewed, setTutorialModalViewedSaga),
		takeLatest(sendThanksForPlayingViewed, sendThanksForPlayingViewedSaga),
		takeLatest(fetchAllLeaderboardsData, fetchAllLeaderboardsDataSaga),
		takeLatest(fetchYesterdayLeaderboard, fetchYesterdayLeaderboardSaga),
		takeLatest(fetchDailyLeaderboard, fetchDailyLeaderboardSaga),
		takeLatest(fetchAllTimeLeaderboard, fetchAllTimeLeaderboardSaga),
		takeLatest(fetchLeaderProfile, fetchLeaderProfileSaga),
		takeLatest(fetchContextualPrompt, fetchContextualPromptSaga),
		takeLatest(declineContextualPrompt, declineContextualPromptSaga),
	]);
};
